import StaticEffect from './StaticEffect.js';

export default StaticEffect.Types;
